var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"level-box",style:({
      backgroundColor: item,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }